import React, { Component } from 'react';
import { Navigation } from '../../navigation/react-redux-nav';
import CoachLogo from './img/coach-logo.svg';
import LoginButton from '../../components/login-button';
import './index.css';

export default class IntroPage extends Component {
  render() {
    return (
      <div className="intro-page">
        <LoginButton />
        <div className="intro-content">
          <img src={ CoachLogo } alt="iFit Coach" />
          <h1>It's what you do&nbsp;next.</h1>
          <p>A personalized fitness app designed to provide you with daily, actionable guidance.</p>
        </div>
        <Navigation.Forward>
          <div className="navigation-button-container">
            <button className="navigation-button">Get Started</button>
          </div>
        </Navigation.Forward>
      </div>
    );
  }
}
